import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const BDMBoardSkeleton: React.FC = () => (
  <div className="bg-gray-50 p-6">
    {/* Stats Card Skeletons */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      {[...Array(3)].map((_, idx) => (
        <div key={idx} className="bg-white rounded-xl shadow p-6">
          <Skeleton height={16} width={120} />
          <div className="mt-2">
            <Skeleton height={32} width={80} />
          </div>
        </div>
      ))}
    </div>

    {/* Table Skeleton */}
    <div className="bg-white rounded-xl shadow overflow-hidden">
      {/* Header */}
      <div className="p-6 border-b flex justify-between items-center">
        <Skeleton height={24} width={200} />
        <Skeleton height={32} width={120} />
      </div>
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            {["Telecaller", "Call Count", "Not Picked Up", "Actions"].map(
              (heading, i) => (
                <th key={i} className="px-6 py-3">
                  <Skeleton height={12} width={heading.length * 10} />
                </th>
              )
            )}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {[...Array(5)].map((_, rowIdx) => (
            <tr key={rowIdx}>
              {[...Array(4)].map((__, colIdx) => (
                <td key={colIdx} className="px-6 py-4">
                  <Skeleton height={16} width={`80%`} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default BDMBoardSkeleton;
